import * as React from 'react';
import { ThemeProvider } from 'telia-front-react';
import icons from '@teliaee/icons/sprite.svg';
import 'telia-front-react/polyfill';
const getIconPath = (name) => icons + name;
const TeliaThemeProvider = (props) => {
    return (React.createElement(ThemeProvider, { getIconPath: getIconPath, brand: props.brand, theme: props.brand === 'super' ? 'dark' : undefined, portalRoot: document.getElementById('telia-header') }, props.children));
};
export default TeliaThemeProvider;
//# sourceMappingURL=TeliaThemeProvider.js.map